import api from "./index";

export interface ExpulsionOrdersListeners {
  courseId: string;
  hasProtocol?: boolean;
  testCompleted?: boolean;
  practiceCompleted?: boolean;
  createdAtMin?: Date;
  createdAtMax?: Date;
  passedAtMin?: Date;
  passedAtMax?: Date;
  offset?: number;
  limit?: number;
  options?: any;
}
export default (params: ExpulsionOrdersListeners) => {
  return api.ExpulsionOrderApi.listeners(
    params.courseId,
    params.hasProtocol,
    params.testCompleted,
    params.practiceCompleted,
    params.createdAtMin,
    params.createdAtMax,
    params.passedAtMin,
    params.passedAtMax,
    params.offset,
    params.limit,
    params.options
  );
};
